import { Button, useTheme } from '@mui/material'
import { EditRounded, SaveAs } from '@mui/icons-material'

const StyledEditButton = (props) => {
  const { active = false, small = false, handleClick = () => {}, altIcon = SaveAs, useAltIcon = false, buttonProps = {} } = props
  const theme = useTheme()
  const Icon = useAltIcon ? altIcon : EditRounded
  return (
    <Button
      sx={{
        minWidth: 0,
        width: '18px',
        boxShadow: `0px 1px 1px ${theme?.palette?.grey?.darkGrey}91`,
        backgroundColor: active ? theme?.palette?.grey?.lighterGrey : theme?.palette?.brand?.primary?.growth,
        ':disabled': {
          backgroundColor: theme?.palette?.grey?.lighterGrey
        }
      }}
      onClick={handleClick}
      {...buttonProps}
    >
      <Icon style={{ color: buttonProps?.disabled ? 'inherit' : theme?.palette?.brand?.primary?.forest, fontSize: small ? '16px' : '18px' }} />
    </Button>
  )
}

export default StyledEditButton
